import { codeSplit } from 'bernie-core';

export interface VideoPlayerProps {
  videoTitle: string;
  videoStaticImage: any;
  videoTitleCopySizeMobile: string;
  videoTitleCopySizeDesktop: string;
  videoFile: any;
  videoCopyColor: string;
  videoCopyWeight: string;
  videoHoverImage: any;
}

export const CodeSplitVideoDetailsMap = codeSplit(
  () => import(/* webpackChunkName: "cp-cmslite-video-details" */ '../video-details') as any
);
